import cn from 'classnames'

import aiVideo from '@/assets/AI.mp4'
import icVideo from '@/assets/IC.mp4'
import maVideo from '@/assets/MA.mp4'
import maPoster from '@/assets/thumb/1.png'
import icPoster from '@/assets/thumb/2.png'
import aiPoster from '@/assets/thumb/3.png'
import { Video } from '@/components/Video'

import { FeaturesProps } from './Features.types'

export const Features = (props: FeaturesProps) => {
    const { className } = props

    const features = [
        {
            title: 'Mathematical Accuracy',
            description: 'Ensure every total figure is correct with automated checks for rounding and subtotals. The system validates calculations across all financial statements.',
            benefits: ['Eliminate errors', 'Save time on reviews', 'Superior quality of financial statements'],
            videoSrc: maVideo,
            poster: maPoster,
        },
        {
            title: 'Internal Consistency',
            description: 'Automatically checks consistency between financial statements and notes. Identifies discrepancies and ensures data integrity across documents.',
            benefits: ['Catch discrepancies instantly', 'Ensure report consistency', 'Reduce review cycles'],
            videoSrc: icVideo,
            poster: icPoster,
        },
        {
            title: 'Nexly AI',
            description: 'Nexly AI intelligently automates the validation and analysis of financial data while ensuring the highest level of client data security.',
            benefits: ['AI which keeps client\'s data protected and private', 'Spelling errors auto-commented', 'Automated quality assurance'],
            videoSrc: aiVideo,
            poster: aiPoster,
        },
    ]

    return (
        <section id='features' className={cn('py-12 sm:py-16 lg:py-20 bg-gray-50', className)}>
            <div className='container mx-auto px-4'>
                <h2 className='text-3xl sm:text-4xl font-bold text-center mb-10 sm:mb-12 lg:mb-16'>Features</h2>
                <div className='grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12'>
                    {features.map((feature) => (
                        <div key={feature.title} className='bg-gray-50 p-6 sm:p-8 rounded-lg flex flex-col h-full'>
                            <h3 className='text-xl sm:text-2xl font-semibold mb-3 sm:mb-4'>{feature.title}</h3>
                            <p className='text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base'>{feature.description}</p>
                            <Video
                                src={feature.videoSrc}
                                poster={feature.poster}
                                title={feature.title}
                                className='mb-6'
                            />
                            <ul className='space-y-3 flex-grow'>
                                {feature.benefits.map((benefit) => (
                                    <li key={benefit} className='flex items-start'>
                                        <span className='text-success mr-3 text-lg'>✓</span>
                                        <span className='text-gray-700'>{benefit}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
